import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/motion";

export default function NewsPage() {
  const [posts, setPosts] = useState(null);

  useEffect(() => { api.get("/posts").then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);

  return (
    <div data-testid="news-page">
      <PageHeader
        kicker="News"
        title="From the shop floor"
        sub="Install techniques, dealer resources and product updates from Outdoor Display Products."
        image="/assets/img/w-img-2926_5.jpg"
      />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-24">
        {!posts ? (
          <p className="font-mono text-sm uppercase tracking-widest text-slate-500">Loading...</p>
        ) : (
          <div className="grid gap-8 md:grid-cols-2" data-testid="news-grid">
            {posts.map((p, i) => (
              <Reveal key={p.slug} i={i}>
                <Link to={`/news/${p.slug}`} data-testid={`news-card-${p.slug}`} className="group block clip-corner border border-girder bg-steel/50 transition-colors hover:border-hivis/60">
                  <div className="overflow-hidden">
                    <img src={p.image} alt={p.title} loading="lazy" className="aspect-[16/8] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-6">
                    <p className="font-mono text-[11px] uppercase tracking-widest text-hivis">{new Date(p.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
                    <h3 className="mt-2 font-display text-2xl font-bold uppercase leading-tight text-slate-100 group-hover:text-hivis">{p.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-slate-400">{p.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-slate-300 group-hover:text-hivis">Read <ArrowRight className="h-3.5 w-3.5" /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
